export const JACKPOT_MODULE_NAMES = {
    LOCAL: "lokalni",
    GLOBAL: "globalni"
};

export const VOUCHER_MODULE_NAMES = {
    VOUCHERS: "max-vaučeri",
    MY_VOUCHERS: "moji-vaučeri"
};

export const FREE_TO_PLAY_MODULE_NAMES = {
    ACTIVE_TICKETS: "aktivni-tiketi",
    SUBMITTED_TICKETS: "odigrani-tiketi"
};

export const VOUCHER_CATEGORIES = {
    ALL: "All",
    BETTING: "Betting",
    VIRTUAL_GAMES: "Virtual games",
    CASINO: "Casino",
};

export const BETTING_TASKS_MODULES = {
    IN_PROGRESS: "In progress",
    FINISHED: "Finished",
};

export const CONNECTION_EVENTS = {
    CONNECTED: "Connected",
    DISCONNECTED: "Disconnected",
    DISCONNECT: "Disconnect",
    RECIEVE_MESSAGE: "ReceiveMessage"
};